import breadcrumbTemplate from "../common/breadcrumb/breadcrumb.html";
import companiesListTemplate from "./companies-list.html";
import companiesEditTemplate from "./companies-edit.html";


angular.module("companies", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('companies', {
                url: "/companies",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: breadcrumbTemplate,
            })
            .state('companies.list', {
                url: "/list",
                controller: "CompaniesListCtrl",
                template: companiesListTemplate,
                data: { pageTitle: 'Compañias' }
            })
            .state('companies.edit', {
                url: "/edit/:id",
                controller: "CompaniesEditCtrl",
                template: companiesEditTemplate,
                data: { pageTitle: 'Compañias' }
            })
        ;
    }])
;